import moment from "moment";
import { FormFieldComponentEnum } from "pages/customer/pages/settings/pages/users/pages/edit/UserCustomField.interfaces";

export function deviationEmailValues(field: any, t: any) {
    const { component, value, labelDefault, labelKey, options, id } = field;

    const ignoreLabelKeys = new Set([
        "vehicle_damage_S4_FG1_FF2",
        "vehicle_damage_S4_FG1_FF1",
        "vehicle_damage_S4_FG1_FF3",
        "vehicle_damage_S4_FG1_FF5",
    ]);
    if (ignoreLabelKeys.has(labelKey)) {
        return null;
    }

    const prefix = "deviation.";
    const label = String(t(prefix + labelKey, labelDefault || labelKey || "-"));
    let val: any = value;

    if (typeof val === "boolean") {
        val = val ? t("global.yes", "Yes") : t("global.no", "No");
    }

    switch (component) {
        case FormFieldComponentEnum.CardButton: {
            const selected = options?.find((x: any) => x.id?.toString() === value);
            const displayVal = selected?.labelDefault ?? "-";
            return { label, value: displayVal };
        }

        case FormFieldComponentEnum.RadioButtons:
        case FormFieldComponentEnum.BigRadioButtons:
        case FormFieldComponentEnum.Select: {
            const opt = options?.find((x: any) => x.value?.toString() === value);
            const displayVal = opt ? t(prefix + opt.labelKey, opt.labelDefault || "") : "-";
            return { label, value: displayVal };
        }

        case FormFieldComponentEnum.VehiclePicker: {
            try {
                const parsed = typeof value === "string" ? JSON.parse(value) : value;
                if (parsed) {
                    const displayVal = `${parsed.RegNumber ?? "-"} ${parsed.Internnumber ?? ""}`.trim();
                    return { label, value: displayVal };
                }
            } catch {
                return { label, value: "-" };
            }
            return { label, value: "-" };
        }

        case FormFieldComponentEnum.LocationPicker: {
            try {
                const parsed = typeof value === "string" ? JSON.parse(value) : value;
                const displayVal = parsed?.interpretedValue ?? "-";
                return { label, value: displayVal };
            } catch {
                return { label, value: "-" };
            }
        }

        case FormFieldComponentEnum.DatePicker:
        case FormFieldComponentEnum.DateTimePicker: {
            const displayVal = moment(value).isValid()
                ? moment(value).format("YYYY-MM-DD")
                : "-";
            return { label, value: displayVal };
        }

        case FormFieldComponentEnum.Checkbox:
        case FormFieldComponentEnum.Switch: {
            const displayVal =
                value === "true" || value === true
                    ? t("global.yes", "Yes")
                    : t("global.no", "No");
            return { label, value: displayVal };
        }
        case FormFieldComponentEnum.Upload: {
            return null;
        }

        default: {
            const displayVal = val ?? "-";
            return { label, value: displayVal };
        }
    }
}
